import { css } from '@emotion/react'
import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

import { Z_INDEX_DESKTOP_ARTICLE_BUTTON_GROUP } from 'components/organisms/articleActionButtonGroup/index.styled'

import { atomic } from './atomic'
import { display } from './display'

const GlobalStyle = css`
  html {
    min-width: 320px;
    font-family: ${process.env.NEXT_PUBLIC_DEPLOY_LOCALE === 'km-KH'
          ? 'Battambang,'
          : process.env.NEXT_PUBLIC_DEPLOY_LOCALE === 'th-TH'
          ? 'Noto Sans Thai,'
          : 'Inter,'} -apple-system,
      BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell,
      'Helvetica Neue', sans-serif;
    scroll-behavior: smooth;
    --app-height: 100vh;
    --mobile-bottom-height: 56px;
  }

  html.quick-booking-noscroll,
  html.quick-booking-noscroll body {
    overflow: hidden !important;
  }
  html.ad-noscroll body {
    overflow: hidden !important;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html,
  body,
  div,
  span,
  object,
  iframe,
  figure,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  code,
  em,
  img,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  b,
  u,
  i,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  main,
  canvas,
  embed,
  footer,
  header,
  nav,
  section,
  video {
    padding: 0;
    border: 0;
    margin: 0;
    font-size: 100%;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    text-size-adjust: none;
    vertical-align: baseline;
  }

  a {
    text-decoration: inherit;
    color: inherit;
  }

  footer,
  header,
  nav,
  section,
  main {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input {
    margin: 0;
    -webkit-appearance: none;
    border-radius: 0;
  }

  input,
  button,
  textarea,
  select {
    display: block;
    /* width: 100%; */
    padding: 0;
    border: 0;
    margin: 0;
    appearance: none;
    background: none;
    border-radius: 0;
    color: inherit;
    font: inherit;
    letter-spacing: inherit;
    outline: none;
  }

  button:focus,
  input:focus,
  div:focus {
    outline: none;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }

  img:not([src]):not([srcset]) {
    visibility: hidden;
  }

  .noscroll {
    overflow: hidden;
  }

  body.leadgen-noscroll {
    overflow: hidden !important;
  }

  /* Make clicks pass-through */
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;

    width: 100%;
    height: 3px;
    background: #2d87f3;
  }

  /* Fancy blur effect */
  #nprogress .peg {
    position: absolute;
    right: 0px;
    display: block;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px #2d87f3, 0 0 5px #2d87f3;
    opacity: 1;

    -webkit-transform: rotate(3deg) translate(0px, -4px);
    -ms-transform: rotate(3deg) translate(0px, -4px);
    transform: rotate(3deg) translate(0px, -4px);
  }

  /* Remove these to get rid of the spinner */
  #nprogress .spinner {
    position: fixed;
    z-index: 1031;
    top: 15px;
    right: 15px;
    display: block;
  }

  #nprogress .spinner-icon {
    width: 18px;
    height: 18px;
    box-sizing: border-box;

    border: solid 2px transparent;
    border-top-color: #2d87f3;
    border-left-color: #2d87f3;

    -webkit-animation: nprogress-spinner 400ms linear infinite;
    animation: nprogress-spinner 400ms linear infinite;
    border-radius: 50%;
  }

  .nprogress-custom-parent {
    position: relative;
    overflow: hidden;
  }

  .nprogress-custom-parent #nprogress .spinner,
  .nprogress-custom-parent #nprogress .bar {
    position: absolute;
  }

  @-webkit-keyframes nprogress-spinner {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes nprogress-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  @keyframes leftAppears {
    from {
      left: -20%;
      opacity: 0;
    }
    to {
      left: 0;
      opacity: 1;
    }
  }

  @keyframes leftDisappears {
    from {
      left: 0;
      opacity: 1;
    }
    to {
      left: -20%;
      opacity: 0;
    }
  }

  @keyframes rightAppears {
    from {
      right: -20%;
      opacity: 0;
    }
    to {
      right: 0;
      opacity: 1;
    }
  }

  @keyframes rightDisappears {
    from {
      right: 0;
      opacity: 1;
    }
    to {
      right: -20%;
      opacity: 0;
    }
  }

  @keyframes fading {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  [data-has-badge='true'] img {
    width: 56px;
    height: 23px;
    object-fit: contain;
  }

  // Override the global bottom spacing from hhg-components
  .hhg-subot-landing-page .root-container {
    padding-bottom: 0;
  }
  .root-container {
    padding-bottom: 0;
  }

  body.subot-iframe--opening.leadgen-noscroll .lead-modal {
    opacity: 0 !important;
    pointer-events: none;
  }

  ${atomic}
  ${display}

  #subot--container {
    bottom: var(--subot-bottom, 0px) !important;

    ${MediaQueries.mbDown} {
      right: 10px !important;
    }
  }

  .collapse-sticky-bar {
    .article-bottom-ad {
      margin-bottom: 0px !important;
    }
  }

  /* [data-event-category] * {
    pointer-events: none;
  } */

  html {
    --chat-base-bottom: 20px;
    --cookie-box-height: 172px;
    --chat-offset-height: 60px;
    --si-open-bottom-height: 70px;
    --subot-icon-height: 100px;

    --subot-bottom: calc(var(--chat-base-bottom, 0px));
    --zalo-bottom: calc(var(--chat-base-bottom, 0px));
    --chatwoot-bottom: calc(var(--chat-base-bottom, 0px));
    --chatwoot-holder-bottom: calc(var(--chat-base-bottom, 0px) + 60px);
    --ai-chat-bottom: calc(var(--chat-base-bottom, 0px));

    --hpv-bottom: calc(var(--chat-base-bottom, 0px));
    --chatwoot-bg: url(${CommonGAssets.getAssetPath('blank.png')});

    .hasCookieConfirm {
      --chat-base-bottom: 10px;
    }

    ${MediaQueries.mbDown} {
      --chat-base-bottom: 10px;
      --subot-icon-height: 70px;
      --subot-bottom: calc(var(--mobile-bottom-height, 0px));

      .collapse-sticky-bar {
        --subot-bottom: calc(var(--chat-base-bottom, 0px));
      }

      .si-open-overflow:not(.hasCookieConfirm) {
        --chat-base-bottom: calc(var(--si-open-bottom-height, 0px));
        --chatwoot-bottom: calc(var(--si-open-bottom-height, 0px));
        --subot-bottom: calc(var(--si-open-bottom-height, 0px));
        --ai-chat-bottom: calc(var(--si-open-bottom-height, 0px));
      }
    }
  }
  .has-chatwoot {
    --zalo-bottom: calc(
      var(--chat-offset-height, 0px) + var(--chat-base-bottom, 0px)
    );
    &.hpv-page {
      --chatwoot-bottom: 80px;
      ${MediaQueries.mbUp} {
        --chatwoot-bottom: 110px;
        --chatwoot-holder-bottom: 200px;
      }
    }
    &.taganil-page {
      ${MediaQueries.mbUp} {
        --chatwoot-holder-bottom: 110px;
      }
    }
  }
  .hasChatbot {
    --base-has-chatbot: calc(
      var(--subot-icon-height, 0px) + var(--chat-base-bottom, 0px)
    );
    --zalo-bottom: calc(var(--base-has-chatbot, 0px));
    --chatwoot-bottom: calc(var(--base-has-chatbot, 0px));

    &.has-chatwoot {
      --zalo-bottom: calc(
        var(--base-has-chatbot, 0px) + var(--chat-offset-height, 0px)
      );
    }
  }
  .hasCookieConfirm {
    --base-has-cookie: calc(
      var(--chat-base-bottom, 0px) + var(--cookie-box-height, 0px)
    );
    --subot-bottom: calc(var(--base-has-cookie, 0px));
    --zalo-bottom: calc(var(--base-has-cookie, 0px));
    --chatwoot-bottom: calc(var(--base-has-cookie, 0px));
    --chatwoot-holder-bottom: calc(var(--base-has-cookie, 0px));
    --hpv-bottom: calc(var(--base-has-cookie, 0px));

    &.has-chatwoot {
      --zalo-bottom: calc(
        var(--base-has-cookie, 0px) + var(--chat-offset-height, 0px)
      );
      &.hpv-page {
        --chatwoot-bottom: calc(var(--base-has-cookie, 0px) + 90px);
        --chatwoot-holder-bottom: calc(var(--base-has-cookie, 0px) + 180px);
        --hpv-bottom: calc(var(--base-has-cookie, 90px));

        ${MediaQueries.mbDown} {
          --chatwoot-bottom: calc(var(--base-has-cookie, 0px) + 70px);
        }
      }
    }
    &.hasChatbot {
      --base-has-chatbot-cookie: calc(
        var(--subot-icon-height, 0px) + var(--base-has-cookie, 0px)
      );
      --zalo-bottom: calc(var(--base-has-chatbot-cookie, 0px));
      --chatwoot-bottom: calc(var(--base-has-chatbot-cookie, 0px));

      &.has-chatwoot {
        --zalo-bottom: calc(
          var(--base-has-chatbot-cookie, 0px) + var(--chat-offset-height, 0px)
        );
      }
    }
    .hpv-link {
      --hpv-bottom: calc(var(--base-has-cookie, 0px));
    }
  }

  .woot-widget-bubble {
    bottom: var(--chatwoot-bottom, 0px) !important;
    width: 50px !important;
    height: 50px !important;
    box-shadow: none !important;
    svg {
      margin: 13px !important;
    }
    ::before,
    ::after {
      left: 25px !important;
      top: 13px !important;
    }
    &:hover {
      box-shadow: none !important;
    }
  }
  .zalo-chat-widget {
    right: 15px !important;
    bottom: var(--zalo-bottom, 0px) !important;
    z-index: 2147483000 !important;
  }
  .woot-widget-holder {
    bottom: var(--chatwoot-holder-bottom, 0px) !important;
  }

  .hpv-link {
    position: fixed;
    right: 0;
    bottom: var(--hpv-bottom, 0px) !important;
  }

  @keyframes circle-pulse {
    0% {
      -webkit-transform: scale(0.95);
      transform: scale(0.95);
      -webkit-box-shadow: 0 0 0 0 rgba(77, 170, 87, 0.9);
      box-shadow: 0 0 0 0 rgba(77, 170, 87, 0.9);
    }
    50% {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-box-shadow: 0 0 0 8px rgba(77, 170, 87, 0);
      box-shadow: 0 0 0 8px rgba(77, 170, 87, 0);
    }
    100% {
      -webkit-transform: scale(0.95);
      transform: scale(0.95);
      -webkit-box-shadow: 0 0 0 0 rgba(77, 170, 87, 0);
      box-shadow: 0 0 0 0 rgba(77, 170, 87, 0);
    }
  }
  .woot--bubble-holder {
    position: relative;
    z-index: 1;
  }
  .woot-widget-bubble.woot-elements--right {
    background-image: var(--chatwoot-bg) !important;
  }
  .hpv-page.replace-chatwoot-icon .woot-widget-bubble.woot-elements--right {
    background-color: transparent !important;
  }
  .replace-chatwoot-icon {
    .woot-widget-bubble {
      svg {
        display: none;
      }
      &,
      &:hover {
        box-shadow: none !important;
      }
    }
    .woot-widget-bubble.woot-elements--right {
      background-color: #fff !important;
      background-size: cover !important;
      background-repeat: no-repeat;
    }
    .woot-widget-bubble.woot--close {
      background: #fff !important;
      &:before,
      &:after {
        background-color: #585858 !important;
      }
    }
  }
  .chatwoot-expand-style {
    .woot-widget-bubble.woot-elements--right {
      right: 0 !important;
      background-image: url(${CommonGAssets.getAssetPath(
        'roche/chat-with-doctor.png',
      )}) !important;
      background-color: transparent !important;
      width: 184px !important;
      height: 64px !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      transform: rotate(0) !important;
      transition: width 0.3s ease !important;
      &.woot--close {
        width: 180px !important;
        opacity: 0 !important;
        &:after {
          content: none;
        }
      }
      &.woot--hide:not(.woot--close) {
        bottom: var(--chatwoot-bottom, 0px) !important;
        top: unset !important;
        opacity: 1;
        visibility: visible !important;
        z-index: 1 !important;
      }
      ${MediaQueries.mbUp} {
        width: 230px !important;
        height: 80px !important;
        &:hover {
          width: 364px !important;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: auto !important;
        bottom: 10px !important;
        right: auto !important;
        left: 56px !important;
        background: #00b16a;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        animation: circle-pulse 2s infinite;
      }
      ${MediaQueries.mbDown} {
        right: 0 !important;

        &:before {
          bottom: 7px !important;
          left: 42px !important;
        }
      }
    }
  }
  .hpv-page {
    .woot-widget-bubble.woot-elements--right {
      background-image: url(${CommonGAssets.getAssetPath(
        'roche/chat-with-doctor.png',
      )}) !important;
      width: 184px !important;
      height: 64px !important;
      ${MediaQueries.mbUp} {
        width: 230px !important;
        height: 80px !important;
        &:hover {
          width: 364px !important;
        }
      }
    }
  }

  .taganil-page {
    .woot-widget-bubble.woot-elements--right {
      background-image: url(${CommonGAssets.getAssetPath(
        'taganil/chat-with-doctor.png',
      )}) !important;
      width: 64px !important;
      height: 64px !important;
      ${MediaQueries.mbUp} {
        width: 80px !important;
        height: 80px !important;
        &:hover {
          width: 227px !important;
        }
      }
    }
  }

  ${MediaQueries.mbDown} {
    .article-page {
      .woot-widget-bubble,
      .zalo-chat-widget {
        display: none;
      }
    }
    .woot-widget-bubble.woot-elements--right {
      right: 10px !important;
    }
    .zalo-chat-widget {
      right: 6px !important;
    }
    .si-open-overflow {
      overflow: hidden !important;
      height: 100vh;
      width: 100%;
    }
  }

  .carepath-body #site-header {
    position: relative;
    border-bottom: 0;
  }
  .carepath-body #site-header > div:first-of-type {
    position: relative;
    z-index: 2;
    background: white;
    border-bottom: 1px solid #e4e8ec;
  }
  .carepath-body #site-header #sticky-sub-nav {
    z-index: 1;
  }
  .carepath-body #site-header[data-collapsed='true'] + #sticky-sub-nav {
    transform: translate(0, -70px);
  }
  ${MediaQueries.mbDown} {
    .desktop-only {
      display: none;
    }
    .carepath-body #navigation-v2 [data-sticky-sponsor] {
      position: relative;
      z-index: 1;
    }
  }
  ${MediaQueries.mbUp} {
    .mobile-only {
      display: none;
    }
  }
  .hhg-page-container {
    width: 100%;
    margin: 0 auto;

    ${MediaQueries.mbDown} {
      padding: 0 16px;
    }

    ${MediaQueries.mbUp} {
      max-width: 1170px;
    }
  }

  [data-event-category] {
    pointer-events: initial !important;
    > *:not(a[href]) {
      pointer-events: none;
    }
    iframe {
      pointer-events: initial;
    }
  }

  .sso-v2-opening {
    [id^='div-gpt-ad-video'],
    [id^='vr-'][class^='vr-'][class*='-vip'] {
      opacity: 0 !important;
      pointer-events: none !important;
    }
  }

  /* vr-uc7eidn8tio-wrapper */
  /* HHD-6026 only show sticky when has no masthead */
  body.hide-sticky-ads .sticky-bottom-ad {
    transform: translateY(100%);
  }

  .js-with-article-act-btn-group {
    position: relative;
    z-index: ${Z_INDEX_DESKTOP_ARTICLE_BUTTON_GROUP + 1};
  }

  ${MediaQueries.mbDown} {
    html[style*='--mobile-bottom-height']
      :not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_)
      [data-gc-instream-floating='true'] {
      bottom: 0 !important;
    }
  }
  .unique-content-wrapper
    div[class*='-brand-showheroes']
    div[class*='-aspect-ratio-landscape'] {
    z-index: 100 !important;
  }
`

export default GlobalStyle
